import React from 'react'
import {UserProvider} from '../../application/authentication/context/userContext'
import {AuthProvider} from '../../application/authentication/context/authContext'

export const buildProviders = app => (
  <AuthProvider>
    <UserProvider>{app}</UserProvider>
  </AuthProvider>
)
